
import { defineComponent, computed, PropType, onMounted } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { useForm } from 'vee-validate'
import { KoteishisanUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'

type InputForm = {
  itemName: string;
  summary: string | null;
}

const validationSchema = object({
  itemName: myValidationSchemaObj.maxString(20),
  summary: myValidationSchemaObj.nullableMaxString(50)
})

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<KoteishisanUiItem>,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    upItem: (item: KoteishisanUiItem) => true,
    downItem: (item: KoteishisanUiItem) => true,
    trashItem: (item: KoteishisanUiItem) => true,
    changeInput: (item: KoteishisanUiItem) => true
  },
  setup (props, { emit }) {
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        itemName: props.item.item.itemName,
        summary: props.item.item.summary
      }
    })
    const headerName = computed(() => {
      if (!values.itemName) {
        return validationMessage.enterItem
      }
      return values.itemName
    })

    const onClickedUpItem = () => {
      emit('upItem', props.item)
    }

    const onClickedDownItem = () => {
      emit('downItem', props.item)
    }

    const onClickedTrashItem = () => {
      emit('trashItem', props.item)
    }

    const onChange = async () => {
      const item = props.item
      item.item.itemName = values.itemName
      item.item.summary = values.summary
      await validate()
      item.isValid = meta.value.valid
      emit('changeInput', item)
    }

    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem: KoteishisanUiItem = props.item
      switch (panelName) {
        case 'normal':
          propItem.item.normalSetting = item
          break
        case 'ruikei':
          propItem.item.ruikeiSetting = item
          break
        case 'shoukyakuhi':
          propItem.item.shoukyakuhiSetting = item
          break
        default:
          throw new Error('unknown panel name')
      }
      emit('changeInput', propItem)
    }

    onMounted(async () => {
      await validate()
      const item = props.item
      item.isValid = meta.value.valid
      emit('changeInput', item)
    })

    return {
      headerName,
      errors,
      values,
      onClickedUpItem,
      onClickedDownItem,
      onClickedTrashItem,
      onChange,
      onUpdateKmk
    }
  }
})
